import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import { ArrowRightIcon } from '../icons/arrow-right.icon'

interface AppspacePartnersProps {
  appspacePartnersBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    text: TranslateOptions
    cta: TranslateOptions
    url: string
    items: AppspacePartnersCardProps[]
    idSection?: string
  }
}

interface AppspacePartnersCardProps {
  logo: string
  title: TranslateOptions
  text: TranslateOptions
  cta: TranslateOptions
  url: string
}

export default function AppspacePartners({
  appspacePartnersBanner,
}: AppspacePartnersProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  return (
    <c.Container px={['s5', 0]} id={appspacePartnersBanner?.idSection}>
      <c.Flex
        p="s5"
        bg="black.0"
        borderRadius="20px"
        direction={['column', 'row']}
        justify="space-between"
        gap="m4"
      >
        <c.Flex
          h={['full', '183px']}
          w={['full', '189px']}
          direction="column"
          gap="s3"
        >
          <c.Text
            color="primary.500"
            fontWeight="bold"
            fontSize="t-xs.0"
            textTransform="uppercase"
          >
            {translateText(appspacePartnersBanner?.subtitle)}
          </c.Text>
          <c.Heading fontSize={['h-sm.0', 'h-lg.0']}>
            {translateText(appspacePartnersBanner?.title)}
          </c.Heading>
          <c.Text fontSize="t-sm.0">
            {translateText(appspacePartnersBanner?.text)}
          </c.Text>
        </c.Flex>

        <c.Flex justify="center" flexWrap="wrap" gap="s2">
          {appspacePartnersBanner?.items?.map((item, i) => (
            <Content {...item} key={i} />
          ))}

          {isMobile ? (
            <c.Button
              as={c.Link}
              isExternal
              href={appspacePartnersBanner?.url}
              variant="primary"
              rightIcon={
                <c.Icon as={ArrowRightIcon} color="black.0" h="12px" w="12px" />
              }
              w="full"
              borderRadius="full"
            >
              {translateText(appspacePartnersBanner?.cta)}
            </c.Button>
          ) : (
            <c.Flex
              as={c.Link}
              isExternal
              href={appspacePartnersBanner?.url}
              w={['full', '152px']}
              bg="primary.500"
              borderRadius="20px"
              direction="column"
              align="center"
              justify="center"
              gap="s5"
            >
              <c.Heading
                color="black.0"
                fontSize="h-xs.0"
                textAlign="center"
                maxW={['full', '110px']}
              >
                {translateText(appspacePartnersBanner?.cta)}
              </c.Heading>

              <c.IconButton
                icon={
                  <c.Icon
                    as={ArrowRightIcon}
                    color="primary.500"
                    h="12px"
                    w="12px"
                  />
                }
                aria-label=""
                borderRadius="full"
              />
            </c.Flex>
          )}
        </c.Flex>
      </c.Flex>
    </c.Container>
  )
}

function Content(props: AppspacePartnersCardProps) {
  return (
    <c.Flex
      p="s3"
      w={['152px', '183px']}
      bg="black.50"
      border="1px solid"
      borderColor="black.150"
      borderRadius="20px"
      direction="column"
      align="center"
      justify="space-between"
    >
      <c.Text fontSize="t-sm.0" fontWeight="bold" mb="s5">
        {translateText(props.title)}
      </c.Text>
      <c.Image
        src={props.logo}
        alt={translateText(props.title) as string}
        h="40px"
        w="40px"
        objectFit="contain"
        borderRadius="8px"
      />
      <c.Text color="black.400" fontSize="t-sm.0" textAlign="center" my="s1">
        {translateText(props.text)}
      </c.Text>

      <c.Button
        as={c.Link}
        isExternal
        href={props.url}
        variant="successOutline"
        fontSize="t-sm.0"
        textTransform="uppercase"
        borderRadius="full"
        maxH="30px"
        rightIcon={
          <c.Icon as={ArrowRightIcon} color="green.500" h="10px" w="10px" />
        }
      >
        {translateText(props.cta)}
      </c.Button>
    </c.Flex>
  )
}
